import Time from 'src/mixins/Time';

export default {
  mixins: [Time],

  computed: {
    periodPresetsAll() {
      const nowStart = this.adjustDate(new Date(), { hour: 0, minute: 0, second: 0 });
      const nowEnd = this.adjustDate(new Date(), { hour: 23, minute: 59, second: 59 });

      return [
        {
          label: this.$t('insights.chartConfigurator.periodPresetToday'),
          id: 'today',
          fromTimestamp: nowStart,
          toTimestamp: nowEnd,
          scope: 'present',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPresetYesterday'),
          id: 'yesterday',
          fromTimestamp: this.startOfDate(this.subtractFromDate(nowStart, { days: 1 }), 'day'),
          toTimestamp: this.subtractFromDate(nowEnd, { days: 1 }),
          scope: 'past',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPresetTomorrow'),
          id: 'tomorrow',
          fromTimestamp: this.startOfDate(this.addToDate(nowStart, { days: 1 }), 'day'),
          toTimestamp: this.addToDate(nowEnd, { days: 1 }),
          scope: 'future',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPreset7D'),
          id: 'prev-7-days',
          fromTimestamp: this.startOfDate(this.subtractFromDate(nowStart, { days: 6 }), 'day'),
          toTimestamp: nowEnd,
          scope: 'past',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPresetN7D'),
          id: 'next-7-days',
          fromTimestamp: nowStart,
          toTimestamp: this.startOfDate(this.addToDate(nowEnd, { days: 7 }), 'day'),
          scope: 'future',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPreset14D'),
          id: 'prev-14-days',
          fromTimestamp: this.startOfDate(this.subtractFromDate(nowStart, { days: 13 }), 'day'),
          toTimestamp: nowEnd,
          scope: 'past',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPresetN14D'),
          id: 'next-14-days',
          fromTimestamp: nowStart,
          toTimestamp: this.startOfDate(this.addToDate(nowEnd, { days: 14 }), 'day'),
          scope: 'future',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPreset30D'),
          id: 'prev-30-days',
          fromTimestamp: this.startOfDate(this.subtractFromDate(nowStart, { days: 29 }), 'day'),
          toTimestamp: nowEnd,
          scope: 'past',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPresetN30D'),
          id: 'next-30-days',
          fromTimestamp: nowStart,
          toTimestamp: this.startOfDate(this.addToDate(nowEnd, { days: 30 }), 'day'),
          scope: 'future',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPreset90D'),
          id: 'prev-90-days',
          fromTimestamp: this.startOfDate(this.subtractFromDate(nowStart, { days: 89 }), 'day'),
          toTimestamp: nowEnd,
          scope: 'past',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPresetN90D'),
          id: 'next-90-days',
          fromTimestamp: nowStart,
          toTimestamp: this.startOfDate(this.addToDate(nowEnd, { days: 90 }), 'day'),
          scope: 'future',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPreset183D'),
          id: 'prev-183-days',
          fromTimestamp: this.startOfDate(this.subtractFromDate(nowStart, { days: 182 }), 'day'),
          toTimestamp: nowEnd,
          scope: 'past',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPresetN183D'),
          id: 'next-183-days',
          fromTimestamp: nowStart,
          toTimestamp: this.startOfDate(this.addToDate(nowEnd, { days: 183 }), 'day'),
          scope: 'future',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPreset365D'),
          id: 'prev-365-days',
          fromTimestamp: this.startOfDate(this.subtractFromDate(nowStart, { days: 364 }), 'day'),
          toTimestamp: nowEnd,
          scope: 'past',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPresetN365D'),
          id: 'next-365-days',
          fromTimestamp: nowStart,
          toTimestamp: this.startOfDate(this.addToDate(nowEnd, { days: 365 }), 'day'),
          scope: 'future',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPresetLastWeek'),
          id: 'last-week',
          fromTimestamp: this.subtractFromDate(nowStart, { days: (this.getDayOfWeek(nowStart) + 6) }),
          toTimestamp: this.subtractFromDate(nowEnd, { days: (this.getDayOfWeek(nowEnd)) }),
          scope: 'past',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPresetThisWeek'),
          id: 'this-week',
          fromTimestamp: this.subtractFromDate(nowStart, { days: (this.getDayOfWeek(nowStart)) - 1 }),
          toTimestamp: this.addToDate(nowEnd, { days: (7 - this.getDayOfWeek(nowEnd)) }),
          scope: 'present',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPresetNextWeek'),
          id: 'next-week',
          fromTimestamp: this.addToDate(
            this.subtractFromDate(nowStart, { days: this.getDayOfWeek(nowStart) - 1 }),
            { days: 7 },
          ),
          toTimestamp: this.addToDate(
            this.addToDate(nowEnd, { days: 7 - this.getDayOfWeek(nowEnd) }),
            { days: 7 },
          ),
          scope: 'future',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPresetLastMonth'),
          id: 'last-month',
          fromTimestamp: this.startOfDate(
            this.subtractFromDate(
              this.startOfDate(nowStart, 'month'),
              { days: 1 },
            ),
            'month',
          ),
          toTimestamp: this.endOfDate(this.subtractFromDate(this.startOfDate(nowEnd, 'month'), { days: 1 }), 'month'),
          scope: 'past',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPresetThisMonth'),
          id: 'this-month',
          fromTimestamp: this.startOfDate(nowStart, 'month'),
          toTimestamp: this.endOfDate(nowEnd, 'month'),
          scope: 'present',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPresetNextMonth'),
          id: 'next-month',
          fromTimestamp: this.startOfDate(
            this.addToDate(nowStart, { months: 1 }),
            'month',
          ),
          toTimestamp: this.endOfDate(
            this.addToDate(nowEnd, { months: 1 }),
            'month',
          ),
          scope: 'future',
        },
        {
          label: this.$t('insights.chartConfigurator.periodPresetAllTime'),
          id: 'all-time',
          fromTimestamp: new Date(2000, 0, 1, 0, 0, 0),
          toTimestamp: new Date(2100, 0, 1, 0, 0, 0),
          scope: 'all',
        },
        { id: 'custom', label: this.$t('dateRangeSelector.fixedPresetCustom'), scope: 'fixed' },
        { id: 'fixed-1-day', label: this.$t('dateRangeSelector.fixedPreset1Day'), days: 1, scope: 'fixed' },
        { id: 'fixed-7-days', label: this.$t('dateRangeSelector.fixedPreset7Days'), days: 7, scope: 'fixed' },
        { id: 'fixed-14-days', label: this.$t('dateRangeSelector.fixedPreset14Days'), days: 14, scope: 'fixed' },
        { id: 'fixed-30-days', label: this.$t('dateRangeSelector.fixedPreset30Days'), days: 30, scope: 'fixed' },
        { id: 'fixed-90-days', label: this.$t('dateRangeSelector.fixedPreset90Days'), days: 90, scope: 'fixed' },
        { id: 'fixed-183-days', label: this.$t('dateRangeSelector.fixedPreset183Days'), days: 183, scope: 'fixed' },
        { id: 'fixed-365-days', label: this.$t('dateRangeSelector.fixedPreset365Days'), days: 365, scope: 'fixed' },
      ];
    },

    periodPresets() {
      return this.periodPresetsAll.filter((preset) => ['past', 'present', 'all'].includes(preset.scope));
    },

    fixedPeriodPresets() {
      return this.periodPresetsAll.filter((preset) => ['fixed'].includes(preset.scope));
    },
  },
};
